module.exports = __webpack_public_path__ + "media/src/images/logos/fullcontact-4dfe218985173bca313a3812367aa770.png";